export default import.meta.ROLLDOWN_FILE_URL_cmJ3J_LahxYYmdf20gDC4w